export const selfEmployedImage1 = "/assets/jpg/selfinvoice1.jpg";
export const selfEmployedImage2 = "/assets/jpg/selfinvoice2.jpg";
export const selfEmployedImage3 = "/assets/jpg/selfinvoice3.jpg";
export const selfEmployedImage4 = "/assets/jpg/selfinvoice4.jpg";
export const selfEmployedImage5 = "/assets/jpg/selfinvoice5.jpg";
export const selfEmployedImage6 = "/assets/jpg/selfinvoice6.jpg";

export const businessRegistrationIcon = "/assets/svg/boundingbox.svg";
export const timerIcon = "/assets/svg/timer.svg";
export const fileIcon = "/assets/svg/4.svg";
export const walletIcon = "/assets/svg/alt1.svg";
